import { isRejectedWithValue } from "@reduxjs/toolkit";
import { createListenerMiddleware } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { persistor } from "../../app/store/store";

const listenerMiddleware = createListenerMiddleware();

const TOAST_ID = "authErrorToast";

listenerMiddleware.startListening({
  matcher: isRejectedWithValue,
  effect: (action, listenerApi) => {
    if (["userLogin", "login"].includes(action?.meta?.arg?.endpointName))
      return;
    if (action.payload.status === 401) {
      listenerApi.dispatch(() => {
        persistor.purge();
        if (!toast.isActive(TOAST_ID)) {
          toast.info("Sessione scaduta, effettuare nuovamente l'accesso", {
            toastId: TOAST_ID,
          });
        }
      });
    }
  },
});

export default listenerMiddleware;
